export default __webpack_public_path__ + "static/media/AnnualVolatility.df33ab1f.svg";